import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { store, persistor } from "./redux/store.js";
import App from "./containers/App.tsx";
import "assets/scss/main.scss";
import SuiKit from "./context/SuiKit.js";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <SuiKit>
        <App />
      </SuiKit>
    </PersistGate>
  </Provider>
);

if (import.meta.env.VITE_BASE_URL != "http://localhost:3006/api/") {
  // console.log = function () {};
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals 